import { useQuery } from '@tanstack/react-query';
import { getLegSummaries } from '../../../../utils/OrderWebAPIUtils';
async function getLegNumbers({ queryKey, }) {
    var _a;
    const [, id] = queryKey;
    if (!id)
        return [];
    const res = await getLegSummaries(id);
    return ((_a = res === null || res === void 0 ? void 0 : res.entity) !== null && _a !== void 0 ? _a : []);
}
export const useShipmentLegNumbers = ({ id }) => {
    return useQuery({
        queryKey: ['legNumbers', id],
        queryFn: getLegNumbers,
        enabled: !!id,
    });
};
